import FormWrapper from '@/components/form-wrapper/form-wrapper-component';
import Link from '@/components/link/link-component';
import PageWrapper from '@/components/page-wrapper/page-wrapper-component';
import { Heading1Text } from '@/utils/global-fonts';
import { FiChevronLeft } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useMutation } from '@/hooks/use-api';
import forgotPasswordApi from '@/api/post/forgot-password';
import Alert from '@/components/alert/alert-component';
import ForgotPasswordForm from './forgot-password-form';

/**
 * Forgot password page.
 * @returns {JSX.Element} The rendered ForgotPassword page.
 */
const ForgotPassword = () => {
  const navigate = useNavigate();
  const [forgotPassword, { loading: loginLoading }] =
    useMutation(forgotPasswordApi);

  return (
    <PageWrapper>
      <Container>
        <BackIcon fontSize="20px" mr="12px" />
        <Link to="/login">Back</Link>
      </Container>
      <Heading1Text>Forgot Password</Heading1Text>
      <FormWrapper
        defaultValues={{
          email: '',
        }}
        onSubmit={(submitData) => {
          forgotPassword(submitData).then(() => {
            Alert({
              icon: 'success',
              text: 'Forgot Password email sent successfully. Please check your email.',
            });
            navigate('/login');
          });
        }}
      >
        <ForgotPasswordForm loading={loginLoading} />
      </FormWrapper>
    </PageWrapper>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 24px;
`;

const BackIcon = styled(FiChevronLeft)`
  margin-right: ${({ mr }) => mr};
  font-size: ${({ fontSize }) => fontSize};
`;

export default ForgotPassword;
